<template>
  <SubContent @back="$router.go(-1)" :noBack="userRole === 'expert'">
     <template v-slot:nav_left>
       {{name}}机构教案库
    </template>
    <div class="search_wrap">
      <div class="select_box">
        年份
        <select v-model="year" @change="changeQuery(true)">
          <option value="0">全部年份</option>
          <option v-for="(item) in yearList" :key="item.value" :value="item.value">{{ item.value }}年
          </option>
        </select>
      </div>
      <div class="select_box">
        分类
        <select v-model="categoryId" @change="changeQuery(true)">
          <option value="">全部</option>
          <option v-for="(item, index) in tutorialType" :key="index" :value="item.id">{{item.nameZh}}</option>
        </select>
      </div>
      <!--<div class="select_box">-->
        <!--共享状态-->
        <!--<select v-model="sharingStatus" @change="changeQuery(true)">-->
          <!--<option value="">全部</option>-->
          <!--<option value="Club">内部可看</option>-->
          <!--<option value="Private">仅个人可看</option>-->
        <!--</select>-->
      <!--</div>-->
    </div>
    <div class="tutorial_wrap">
      <div class="scroll_wrap">
        <vue-scroll v-show="dataReay">
          <div class="tutorial">
            <div
              v-for="(item, index) in tutorial"
              :key="index"
              class="item_box"
              @click="goDetail(item.uuid)">
              <div class="flex_box">
                <img :src="item.coverImgUrl" alt="">
                <p :title="item.title">{{item.title}}</p>
              </div>
              <div class="info">
                <div>
                  <p>作者：{{item.authorName}}</p>
                  <p>分类：{{item.categoryZh}}</p>
                </div>
                <div>
                  <p>球队：{{item.skillLevelZh}}</p>
                  <p>更新：{{item.updatedAt | time(true)}}</p>
                </div>
              </div>
            </div>
          </div>
        </vue-scroll>
        <yioks-empty v-if="empty"></yioks-empty>
        <yioks-loading v-if="loading"></yioks-loading>
      </div>
      <Pagination :total="total" :page.sync="page"/>
    </div>
  </SubContent>
</template>

<script>
import tutorial from '@/api/tutorial'
import {filterCode} from '@/utils/yioks_filter'
import storage from '@/utils/storage'
export default {
  components: {
    'SubContent': () => import('@/components/layout/SubContent'),
    'Pagination': () => import('@/components/Pagination')
  },
  data () {
    return {
      name: this.$route.query.name,
      youthUuid: this.$route.query.uuid,
      userRole: storage.get('userInfo').userRole,
      total: 0,
      tutorial: [],
      year: 0,
      categoryId: '',
      language: '',
      sharingStatus: '',
      tutorialType: [],
      loading: true,
      empty: false,
      dataReay: false,
      page: 0,
      tutorialNum: {
        Club: 0,
        Count: 0,
        Private: 0
      }
    }
  },
  computed: {
    // 获取2022年至今的年份数组
    yearList() {
      let year = new Date().getFullYear()
      let yearList = []
      for (var i = 0; i <= (year - 2022); i++) {
        yearList.push({value: (2022 + i), label: (2022 + i)})
      }
      return yearList
    }
  },
  watch: {
    page () {
      this.getTutorial(false)
    }
  },

  created () {
    if (!this.youthUuid) {
      this.$router.push('/home/index')
      this.$message.error('教案数据异常')
    }

    const {page, year, uuid,categoryId,name} = this.$route.query
    page && (this.page = Number(page))
    uuid && (this.youthUuid = uuid)
    name && (this.name = name)
    categoryId && (this.categoryId = categoryId)
    if(year){
      this.year = year
    }else{
      this.year = new Date().getFullYear()
    }


    this.getTutorial()
    this.getCommon()
  },
  methods: {
    changeQuery (flag) {
      if (flag) this.page = 0
      this.$router.replace({
        path: this.$route.path,
        query: {
          page: this.page,
          uuid: this.youthUuid,
          year: this.year,
          categoryId: this.categoryId,
          name: this.name,
        }
      })
      this.getTutorial()
    },
    getTutorial () {
      this.loading = true
      this.empty = false
      this.dataReay = false
      let request
      if (this.userRole === 'system' || this.userRole === 'admin' || this.userRole === 'expert') {
        request = tutorial.getOfficialTutorial
      } else if (this.userRole === 'organ') {
        request = tutorial.getOrganTutorial
      } else if (this.userRole === 'youth' || this.userRole === 'trainCamp' || this.userRole === 'club' || this.userRole === 'leader' || this.userRole === 'coach') {
        request = tutorial.getYouthTutorial
      }
      request({
        youthUuid: this.youthUuid,
        page: this.page,
        categoryId: this.categoryId,
        language: this.language,
        year: this.year,
        sharingStatus: this.sharingStatus
      }).then(res => {
        if (res.code) {
          this.$message.error(res.msg)
          this.$router.push('/home/index')
          return
        }
        this.loading = false
        if (res.totalElements) {
          this.tutorial = res.content
          this.dataReay = true
          this.total = res.totalElements
        } else {
          this.empty = true
        }
      }).catch(err => {
        this.loading = false
        console.error(err)
      })
    },
    getCommon () {
      tutorial.getCategory().then(res => {
        this.tutorialType = res
      })
    },

    goDetail (uuid) {
      this.$router.push({
        path: '/tutorial/detail',
        query: { uuid }
      })
    },
  }
}
</script>

<style lang="stylus" scoped>
  .total_wrap
    margin-left .2rem
    span
      margin-left .2rem
      font-size .16rem
      &:first-child
        margin 0
  .search_wrap
    font-size .16rem
    display flex
    padding .3rem
    .select_box
      margin-left .4rem
      &:first-child
        margin 0
      select
        margin-left .2rem
        width 1.5rem
        height .4rem
        padding-left .1rem
  .tutorial_wrap
    height 530px
    display flex
    flex-direction column
    .scroll_wrap
      flex 1
      overflow hidden
      .tutorial
        margin 0 .2rem
        display flex
        flex-wrap wrap
        .item_box
          background rgba(0, 0, 0 ,.35)
          border 2px solid transparent
          padding .2rem
          width 400px
          cursor pointer
          margin-bottom .2rem
          &:nth-child(odd)
            margin-right .2rem
          &:hover
            background rgba(0,0,0,.35) url('~@/assets/images/common/hover_yioks.png') no-repeat right center
            box-shadow inset 0 0 .12rem $green_color
            border 2px solid $green_color
          .flex_box
            display flex
            border-bottom 1px solid #FFF
            padding-bottom .15rem
            img
              margin-right .2rem
              height 1rem
              width 1.7rem
            p
              width 1.45rem
              text-overflow ellipsis
              overflow hidden
              white-space nowrap
          .info
            display flex
            div
              margin-right .2rem
              &:last-child
                margin 0
            p
              margin-top .1rem
</style>
